import {FC, forwardRef, InputHTMLAttributes} from 'react';
import {Controller, useFormContext} from 'react-hook-form';
import {twMerge} from 'tailwind-merge';

import {Checkbox} from '../types';
import {useRights} from './RightsContext';
import {uiDrivenCheckbox} from './styles.module.css';

type CustomCheckboxProps = {
    label: string;
} & InputHTMLAttributes<HTMLInputElement>;
export const CustomCheckbox = forwardRef<HTMLInputElement, CustomCheckboxProps>(
    ({className, disabled, label, name, ...inputProps}, ref) => (
        <label
            className={twMerge(
                'flex items-center text-base',
                disabled ? 'cursor-not-allowed' : 'cursor-pointer',
                className,
            )}
            htmlFor={name}
        >
            <input
                disabled={disabled}
                id={name}
                name={name}
                ref={ref}
                type="checkbox"
                {...inputProps}
            />
            <span className={twMerge(disabled && 'text-grey-400')}>
                {label}
            </span>
        </label>
    ),
);
CustomCheckbox.displayName = 'CustomCheckbox';

const UIDrivenCheckbox: FC<Checkbox> = ({disabled, label, name, value}) => {
    const {control} = useFormContext();
    const {hasRight} = useRights();
    const isCheckboxDisabled = disabled || !hasRight(name);

    return (
        <Controller
            control={control}
            defaultValue={value}
            name={name}
            render={({field: {onBlur, onChange, ref, value: checked}}) => (
                <CustomCheckbox
                    checked={checked}
                    className={uiDrivenCheckbox}
                    disabled={isCheckboxDisabled}
                    label={label}
                    name={name}
                    onBlur={onBlur}
                    onChange={onChange}
                    ref={ref}
                />
            )}
        />
    );
};

export default UIDrivenCheckbox;
